import {HttpClient} from '@angular/common/http';
import {inject, Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {CookieService} from 'ngx-cookie-service';
import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment';
import {UserService} from './user.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  http = inject(HttpClient);
  router = inject(Router);
  cookieService = inject(CookieService);

  login(data: {email: string; senha: string}): Observable<any> {
    return this.http.post<any>(environment.apiUrl + '/login/authenticate', data);
  }

  setToken(token: string, expiration: string): void {
    const [datePart, timePart] = expiration.split(' ');
    const [year, month, day] = datePart.split('-').map(Number);
    const [hours, minutes, seconds] = timePart.split(':').map(Number);
    const expirationDate = new Date(year, month - 1, day, hours, minutes, seconds);

    if (environment.localHostDevelopment) localStorage.setItem('accessToken', token);
    else this.cookieService.set('accessToken', token, expirationDate, '/', undefined, true, 'Lax');
  }

  getToken(): string {
    if (environment.localHostDevelopment) return localStorage.getItem('accessToken') || '';
    else return this.cookieService.get('accessToken') || '';
  }

  logout() {
    this.clearToken();
    this.router.navigate(['/login']);
  }

  isUserAuthenticated(): boolean {
    const token = this.getToken();
    return !!token;
  }

  clearToken() {
    localStorage.clear();
    this.cookieService.deleteAll('/');
  }
}
